module.exports = __webpack_public_path__ + "static/media/migraine.ecca0ef9.jpg";